/**
 * Class strings shared by `Menu.tsx` (dropdown, click-triggered) and
 * `ContextMenu.tsx` (right-click-triggered). Radix ships these as two
 * separate primitives with different trigger semantics, but the same
 * content/item/submenu vocabulary — a menu must not look like two different
 * components depending on how it was opened, so both wrappers style
 * themselves from here rather than keeping their own copies.
 */

/**
 * `max-w` caps the surface at a sane desktop width (20rem) AND at whatever
 * room Radix's own collision detection found at the anchor — the two
 * `--radix-*-content-available-width` vars it sets on whichever of
 * Content/SubContent is actually rendered (dropdown or context menu; only
 * one is ever defined in a given subtree, so the other's fallback is inert).
 * Without this, a menu with no intrinsic width limit sizes to its widest
 * item — a long project or tag name — and Radix can only ever flip which
 * *side* it opens on, never shrink it to fit; at 320px a submenu triggered
 * near mid-screen has so little room on either side that an unbounded-width
 * box overflows the viewport regardless of which side it flips to (see
 * e2e/responsive.spec.ts's "Kontextmenü bei 320px Breite").
 */
export const menuSurface =
  'z-50 min-w-40 max-w-[min(20rem,var(--radix-context-menu-content-available-width,20rem),var(--radix-dropdown-menu-content-available-width,20rem))] ' +
  'rounded-[var(--radius-panel)] border border-rule bg-surface p-1 shadow-(--shadow-popover) focus:outline-none'

export const menuItem =
  'flex cursor-default select-none items-center gap-2 rounded-[var(--radius-control)] px-2 py-1.5 text-base text-ink outline-none break-words ' +
  'data-[highlighted]:bg-sunken data-[disabled]:pointer-events-none data-[disabled]:opacity-50'

export const menuLabel = 'px-2 py-1 text-2xs font-medium text-ink-faint'
